import { render, staticRenderFns } from "./D19.vue?vue&type=template&id=3813039b&scoped=true"
import script from "./D19.vue?vue&type=script&lang=js"
export * from "./D19.vue?vue&type=script&lang=js"
import style0 from "./D19.vue?vue&type=style&index=0&id=3813039b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3813039b",
  null
  
)

export default component.exports